module.exports = __webpack_public_path__ + "static/p1-0231aa3cd4f7a321722287038114ff4d.svg";